import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeroSection from "./HeroSectionVVB";
// import Flow from './Flow'
import Navigation from "../../Navbar";
import About from "./AboutVVB";
import BenefitVVB from "./Benefit";
import Service from "./Service";
import FlowService from "./FlowService";
import Commitment from "./Commitment";
import AppealFlow from "./AppealFlow";
// import ContactUsService from "./ServiceContactUs";
// import Import from './Import';
// import Desc from './Desc';
import ContactUs from "../tkdn/ContactUs";

function VVB() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const contactUs = [
    {
      name: "Marketing LVV",
      email: "lvvgrk.nek@anindya.biz",
      phone: "+62 21-2260-6207",
    },
    {
      name: "Novia Giselaputri Sukandar",
      email: "novia_lsi@anindya.biz",
      phone: " +62 812-9511-1380",
    },
    {
      name: "Meidina Aysha Anindita",
      email: "meidina_lsii@anindya.biz",
      phone: "+62 852-8208-6769",
    },
    {
      name: "Halija Syuchah",
      email: "halija.syuchah@anindya.biz",
      phone: "+61 851-2104-4449",
    },
  ];

  return (
    <>
      <Navigation />
      <HeroSection />
      <About />
      <div style={{ backgroundColor: "#F2F2F2" }}>
        <BenefitVVB />
      </div>
      <Service />
      <div style={{ backgroundColor: "#F2F2F2" }}>
        <FlowService />
      </div>
      <Commitment />
      <div style={{ backgroundColor: "#F2F2F2" }}>
        <AppealFlow />
      </div>
      {/* <ContactUsService /> */}
      <ContactUs data={contactUs} sectionTitle={"contact_title"} />
    </>
  );
}

export default VVB;
